import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmService } from '../confirm/confirm.service';

export type HasUnsavedChanges = {
  canDeactivate: () => boolean | Observable<boolean>;
};

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  const confirmService = inject(ConfirmService);
  const transloco = inject(TranslocoService);

  return (
    !!component.canDeactivate() ||
    confirmService.ask({
      title: transloco.translate('common.confirm'),
      body: transloco.translate('continueWithoutSaving'),
    })
  );
};
